import type { Action } from 'redux';
import type { LinkDataObject } from '../../../../main/types/links';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateLinkData = new ReduxAsyncAction<'UPDATE_LINK_DATA', LinkDataObject[], { linkData: LinkDataObject[] }>(
  'UPDATE_LINK_DATA'
);

UpdateLinkData.registerRequest(async (linkData: LinkDataObject[]) => {
  return { linkData };
});

export const UPDATE_LINK_DATA = UpdateLinkData.actionNamespaceConstants;
export const updateLinkData = UpdateLinkData.request;

export type UpdateLinkDataResponseAction = Action<typeof UPDATE_LINK_DATA.response> & {
  data: { linkData: LinkDataObject[] };
};
